import { checkoutMobx, storeMobx } from '@mobxStore'
import { getHistoryNew } from '@utils'
import React, { FC } from 'react'
import './index.scss'

const DineinWaiter: FC = () => {
  const history = getHistoryNew()
  return (
    <div className='cart-waiter-footer'>
      <div className='cwf-wrapper'>
        <div className='cwf-info'>
          <i className='iconfont icon-sandglass'></i>
          <div>
            <h3>{i18n.t('checkout.contactWaiterToOrder')}...</h3>
            <small>{i18n.t('checkout.orderSubmitWaiterConf')}</small>
          </div>
        </div>
        {!!storeMobx.storeSceneConfig.memberConfirmOrders &&
          !checkoutMobx.isMemberLogin ? (
            <a className='cwf-link' data-cypid='cartWaiterLogin' onClick={() => history.push('/login')}>{i18n.t('checkout.memberLoginFastOrder')}</a>
          ) : null}
        <div
          className='cwf-btn'
          data-cypid='cartWaiterMenu'
          onClick={() => {
            if (history.getPrevState() === '/menu') {
              history.goBack()
            } else {
              history.replace('/menu')
            }
          }}
        >
          {i18n.t('checkout.reChooseProduct')}
        </div>
      </div>
    </div>
  )
}

export default DineinWaiter
